import {Editor, Node} from "../../../../../../pkg/slate.js";
export const isAncestorEmpty = (editor, node) => !Node.string(node) && !node.children.some((n) => Editor.isInline(editor, n));
